import Vue from 'vue'
import { API_URL } from '../../api'
import ComponentTransactionsFilter from '../../filters/ComponentTransactionsFilter';
const state = {
    componentTransactionCreate: {
        createdComponentTransaction: null,
        creatingComponentTransaction: false,
        createComponentTransactionStatus: null
    },
    componentTransactionUpdate: {
        updatedComponentTransaction: null,
        updatingComponentTransaction: false,
        updateComponentTransactionStatus: null
    },
    componentTransactionDelete: {
        deletingComponentTransaction: false,
        deleteComponentTransactionStatus: null
    },
    componentTransactionSearch: {
        componentTransactionsCount: null,
        componentTransactions: [],
        searchingComponentTransactions: false,
        searchComponentTransactionStatus: null
    },
}
const mutations = {
    ['SET_COMPONENT_TRANSACTION_CREATE'](state, change) {
        state.componentTransactionCreate = { ...state.componentTransactionCreate, ...change };
    },
    ['SET_COMPONENT_TRANSACTION_UPDATE'](state, change) {
        state.componentTransactionUpdate = { ...state.componentTransactionUpdate, ...change };
    },
    ['SET_COMPONENT_TRANSACTION_DELETE'](state, change) {
        state.componentTransactionDelete = { ...state.componentTransactionDelete, ...change };
    },
    ['SET_COMPONENT_TRANSACTION_SEARCH'](state, change) {
        state.componentTransactionSearch = { ...state.componentTransactionSearch, ...change };
    }
}
const actions = {
    createComponentTransaction: ({ commit }, payload) => {
        commit('SET_COMPONENT_TRANSACTION_CREATE', { createComponentTransactionStatus: null, createdComponentTransaction: null, creatingComponentTransaction: true })
        return Vue.http.post(API_URL + '/componentTransactions/create', payload).then(response => {
            commit('SET_COMPONENT_TRANSACTION_CREATE', { createComponentTransactionStatus: 'success', createdComponentTransaction: response.body.results.componentTransaction });
        }).catch(response => {
            commit('SET_COMPONENT_TRANSACTION_CREATE', { createComponentTransactionStatus: 'failed' });
        }).finally(() => {
            commit('SET_COMPONENT_TRANSACTION_CREATE', { creatingComponentTransaction: false });
        });
    },
    updateComponentTransaction: ({ commit }, payload) => {
        commit('SET_COMPONENT_TRANSACTION_UPDATE', { updateComponentTransactionStatus: null, updatedComponentTransaction: null, updatingComponentTransaction: true })
        return Vue.http.post(API_URL + '/componentTransactions/update/' + payload.id, payload)
            .then(response => {
                commit('SET_COMPONENT_TRANSACTION_UPDATE', { updateComponentTransactionStatus: 'success', updatedComponentTransaction: response.body.results.componentTransaction });
            })
            .catch(response => {
                commit('SET_COMPONENT_TRANSACTION_UPDATE', { updateComponentTransactionStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_COMPONENT_TRANSACTION_UPDATE', { updatingComponentTransaction: false });
            })
    },
    deleteComponentTransaction: ({ commit }, id) => {
        commit('SET_COMPONENT_TRANSACTION_DELETE', { deleteComponentTransactionStatus: null, deletedComponentTransaction: null, deletingComponentTransaction: true })
        return Vue.http.delete(API_URL + '/componentTransactions/delete/' + id).then(response => {
            commit('SET_COMPONENT_TRANSACTION_DELETE', { deleteComponentTransactionStatus: 'success' });
        }).catch(response => {
            commit('SET_COMPONENT_TRANSACTION_DELETE', { deleteComponentTransactionStatus: 'failed' });
        }).finally(() => {
            commit('SET_COMPONENT_TRANSACTION_DELETE', { deletingComponentTransaction: false });
        })
    },
    searchComponentTransactions: ({ commit }, payload = { filter: ComponentTransactionsFilter(), resultMode: 'default' }) => {
        commit('SET_COMPONENT_TRANSACTION_SEARCH', { searchComponentTransactionStatus: null, searchComponentTransaction: null, searchingComponentTransactions: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/componentTransactions' + params).then(response => {
            commit('SET_COMPONENT_TRANSACTION_SEARCH', { searchComponentTransactionStatus: 'success', componentTransactions: response.body.results.componentTransactions });
        }).catch(response => {
            commit('SET_COMPONENT_TRANSACTION_SEARCH', { searchComponentTransactionStatus: 'failed' });
        }).finally(() => {
            commit('SET_COMPONENT_TRANSACTION_SEARCH', { searchingComponentTransactions: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/componentTransactionStore.js